import { createElement } from 'react'
import {
    UnifiedFilterModule,
    UnifiedFilterConfig,
    SearchKeyConfig,
} from '@core/modules/filters/unified-filter.module'
import { EIssueSeverity } from '@core/modules/issues/constants'
import { SeverityIcon } from '@/ui/components/svg/SeverityIcon'
import { getHighestSeverity } from '@routes/digital-footprint/routes/assets/components/assetsTable/utils'

const devicesSearchKeys: SearchKeyConfig[] = [
    { value: 'hostname', threshold: 0.3 },
    { value: 'issues.severity', threshold: 0.2 },
    { value: 'issues.name', threshold: 0.3 },
]

const config = {
    severity: {
        accessor: 'severity',
        label: 'Severity',
        collapsible: true,
        filters: {
            critical: {
                id: 'critical',
                accessor: 'critical',
                label: 'Critical',
                icon: createElement(SeverityIcon, { severity: 'critical' }),
            },
            important: {
                id: 'important',
                accessor: 'important',
                label: 'Important',
                icon: createElement(SeverityIcon, { severity: 'important' }),
            },
            moderate: {
                id: 'moderate',
                accessor: 'moderate',
                label: 'Moderate',
                icon: createElement(SeverityIcon, { severity: 'moderate' }),
            },
            clean: {
                id: 'clean',
                accessor: 'clean',
                label: 'Excellent',
                icon: createElement(SeverityIcon, { severity: 'clean' }),
            },
        },
    },
}

const defaultFilters = {
    severity: {
        critical: true,
        important: true,
        moderate: true,
        clean: true,
    },
}

const unifiedDevicesConfig: UnifiedFilterConfig = {
    config,
    defaultFilters,
    searchKeys: devicesSearchKeys,
    dataTransformer: (data: TAsset[]) =>
        data.map((asset) => ({
            ...asset,
            severity: getHighestSeverity(asset.issues),
        })),
    sortStrategy: (a: TAsset, b: TAsset) => {
        const getRank = (asset: TAsset) =>
            EIssueSeverity[
                getHighestSeverity(asset.issues) as keyof typeof EIssueSeverity
            ] || 0
        const diff = getRank(b) - getRank(a)
        return diff !== 0
            ? diff
            : (b.issues?.length || 0) - (a.issues?.length || 0)
    },
}

export const unifiedDevicesFilterModule = new UnifiedFilterModule(
    unifiedDevicesConfig,
    'devices.unified.filter'
)
